import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AccountTypeCustomer } from 'app/back-office/account.model';
import { CurrentContextService } from 'app/core/current-context.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-verify-user',
  templateUrl: './verify-user.component.html',
  styleUrls: ['./verify-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VerifyUserComponent implements OnInit, OnDestroy {
  private subscriptionArray: Subscription[] = [];
  private isSelfService: boolean;
  private hasDomain: boolean;

  constructor(
    private router: Router,
    private readonly currentContextService: CurrentContextService,
  ) {}

  ngOnInit(): void {
    this.subscriptionArray.push(
      this.currentContextService.currentContextBS.subscribe((currentContext) => {
        if (currentContext) {
          this.isSelfService = currentContext.customer.type === AccountTypeCustomer.SelfService;
          this.hasDomain = !!currentContext.account.urls[0];
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptionArray.forEach((subscription) => subscription && subscription.unsubscribe());
  }

  public closePage(): void {
    window.open('about:blank', '_self');
    window.self.close();
  }

  public continue(): void {
    // SelfService: Go to same route as when signup is done, then we forward to expected route in case that part is already done
    const route = this.isSelfService ? this.getContinueRoute() : '/';
    this.router.navigate([route]);
  }

  private getContinueRoute(): string {
    return this.hasDomain ? '/' : '/account/domain';
  }
}
